<template>
    <div class="tooltip" v-if="showTooltip">{{ message }}</div>
</template>
  
<script>
    export default {
        name: "ToolTip",
        props: {
            message: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                showTooltip: false
            };
        },
        methods: {
            show() {
                this.showTooltip = true;
            },
            hide() {
                this.showTooltip = false;
            },
        }
    };
</script>

<style scoped>
    .tooltip {
        position: absolute;
        width: fit-content;
        background-color: #333;
        color: #fff;
        padding: 5px;
        border-radius: 3px;
        z-index: 999;
        font-size: 12px;
    }
</style>